(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "createUpdateCampaignController",
      createUpdateCampaignController
    );

  /** @ngInject */
  function createUpdateCampaignController(
    $scope,
    $state,
    $stateParams,
    campaignActions,
    dialogsService,
    CreateUpdateCampaignViewModel,
    brand
  ) {
    var vm = this;
    vm.isEditMode = false;
    vm.brand = brand;

    vm.saveChanges = function() {
      vm.isEditMode
        ? campaignActions
            .updateCampaign(vm.campaign.getDtoForPersistence())
            .then(onSaveUpdateSuccess)
        : campaignActions
            .createCampaign(vm.campaign.getDtoForPersistence())
            .then(onSaveUpdateSuccess);
    };

    vm.cancelChanges = function() {
      $state.go("app.loyalty");
    };

    vm.removeCampaignRule = function(ruleType) {
      dialogsService
        .showConfirmDialog(
          "REMOVE_CAMPAIGN_RULE_TITLE",
          "REMOVE_CAMPAIGN_RULE_CONFIRMATION",
          "OK"
        )
        .then(function() {
          vm.campaign.selectedFacilityType = null;
          vm.campaign.removeRule(ruleType);
        });
    };

    vm.changeFacility = function(facility) {
      vm.campaign.onSelectTemporalDeviceType(facility);
    };

    vm.checktemporalRule = function(value) {
      value % vm.campaign.temporalRulePercentageValue === 0
        ? $scope.campaignForm.daysCreditValue.$setValidity(
            "validationError",
            true
          )
        : $scope.campaignForm.daysCreditValue.$setValidity(
            "validationError",
            false
          );
    };

    init();

    function init() {
      if ($stateParams.id) {
        vm.isEditMode = true;
        vm.id = $stateParams.id;
        vm.facilityType = $stateParams.facilityType;
      }
      vm.campaign = new CreateUpdateCampaignViewModel(vm.id);
      $scope.$watch(function() {
        vm.checkIfDayIsSelected = true;
        if (vm.campaign.dailyTemporalRule) {
          vm.campaign.dailyTemporalRule.daysOfWeek.filter(function(item) {
            if (item.selected) {
              vm.checkIfDayIsSelected = false;
            }
          });
        } else if (vm.campaign.numberOfVisitsRule || vm.campaign.amountOfMoneyRule) {
          vm.checkIfDayIsSelected = false;
        }
      });
      $scope.$on("$destroy", destroy);
    }

    function destroy() {
      vm.campaign.destroy();
    }

    function onSaveUpdateSuccess() {
      $state.go("app.loyalty");
    }
  }
})();
